import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import { noop } from "../../utils/function";
import { BackToTrackingMap as BackToTrackingMapIcon } from "../Icons";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  trackingMap: {
    position: "absolute",
    left: typography.pxToRem(56),
    top: typography.pxToRem(94),
    "& #TRACKING_MAP_CONTAINER": {
      fill: palette.icon.dark
    },
    cursor: "pointer",
    [breakpoints.down("sm")]: {
      left: typography.pxToRem(10),
      top: typography.pxToRem(90)
    }
  }
}), {
  name: "back-tracking-map"
});

const BackToTrackingMap = ({
  onClick = noop,
  children,
  className
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackToTrackingMapIcon, {
    className: clsx(styles.trackingMap, className),
    onClick: onClick
  }), children);
};

export default BackToTrackingMap;